// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"e82949f0","714":"fa2843db"}[chunkId] + ".chunk.css";
};